import { CustomFormatter } from "@messageformat/core"

// @ts-ignore
export const lowerCase: CustomFormatter = (value, locale, arg) => value.toLowerCase()
